import { ALL_POST_FEELINGS } from '../PostFeelingsDialog';

export const EMOJI_LIST = ALL_POST_FEELINGS.map(({ emoji }) => emoji);
